enum RequestType {
  Share = "Share",
  Info = "Info",
  Research = "Research",
}

export default RequestType;
